import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useProactiveTokenRefresh } from '../hooks/useProactiveTokenRefresh';
import { useSessionBootstrap } from '../hooks/useSessionBootstrap';
import {
  initAuthSessionSync,
  tryRestorePublishedSession,
} from '../utils/authSessionCoordinator';

interface AuthSessionGateProps {
  children: React.ReactNode;
}

/** Blocks children until persisted auth state has been restored (avoids redirect flicker). */
const AuthSessionGate: React.FC<AuthSessionGateProps> = ({ children }) => {
  const { ready } = useSessionBootstrap();
  useProactiveTokenRefresh();

  useEffect(() => {
    tryRestorePublishedSession();
    return initAuthSessionSync();
  }, []);

  if (!ready) {
    return (
      <div className="cp-auth-loading">
        <Spin size="large" />
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthSessionGate;
